import { Component, HostListener, ChangeDetectionStrategy, viewChild, signal, DestroyRef } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-modale-changer-mot-passe',
  templateUrl: './modale-changer-mot-passe.component.html',
  styleUrls: ['./modale-changer-mot-passe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ModaleChangerMotPasseComponent {
  modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  ancienMdp = signal<string>('');
  nouveauMdp = signal<string>('');
  confirmMdp = signal<string>('');
  ancienMdpRequis = signal<boolean>(false);
  ancienMdpInvalide = signal<boolean>(false);
  nouveauMdpRequis = signal<boolean>(false);
  nouveauMdpLongMini = signal<boolean>(false);
  mdpDifferents = signal<boolean>(false);
  erreurValidation = signal<boolean>(false);
  modifReussie = signal<boolean>(false);
  username = signal<string>('');

  constructor(
    private readonly http: HttpService,
    public bsModalRef: BsModalRef,
    keycloakUtilisateurService: KeycloakUtilisateurService,
    private readonly fonctionsService: FonctionsService,
    private readonly destroyRef: DestroyRef
  ) {
    this.username.set(keycloakUtilisateurService.userProfile.username);
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  onSubmit() {
    this.ancienMdpInvalide.set(false);
    this.erreurValidation.set(false);
    this.modifReussie.set(false);

    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      let body = { AncienMdp: this.ancienMdp(), NouveauMdp: this.nouveauMdp() };
      this.http.post('Users/UpdatePassword', body)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((resultat: any) => {
          if (resultat && resultat.value && resultat.value.succeeded === true) {
          this.modifReussie.set(true);
          this.ancienMdp.set('');
          this.nouveauMdp.set('');
          this.confirmMdp.set('');
        }
        else {
          this.ancienMdpInvalide.set(true);
        }
        this.fonctionsService.loading_screen(false)
      }, () => {
        this.erreurValidation.set(true);
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  validationFormulaire() {
    this.ancienMdpRequis.set(this.ancienMdp() === null || this.ancienMdp() === undefined || this.ancienMdp() == '');
    this.nouveauMdpRequis.set(this.nouveauMdp() === null || this.nouveauMdp() === undefined || this.nouveauMdp() == '');
    this.nouveauMdpLongMini.set((!this.nouveauMdpRequis() && this.nouveauMdp().length < 10));
    this.mdpDifferents.set(this.nouveauMdp() !== this.confirmMdp());

    return (!this.ancienMdpRequis() && !this.nouveauMdpRequis() && !this.nouveauMdpLongMini() && !this.mdpDifferents());
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel()?.show();
    } else {
      this.bsModalRef.hide();
    }
  }

  diff() {
    return this.nouveauMdp() || this.confirmMdp();
  }
}
